export const environment = {
  production: true,
  baseUrl: 'https://api.ba01-dev.int.nettask.de'
};
